import React from "react";
import { SvgComponent } from "@commons/Componentes/SvgComponent/SvgComponent";

export const RevisionSeccion = ({ titulo, icono, children, className, acciones }) => (
  <div className={`citrus-ia-seccion${className ? ` ${className}` : ""}`}>
    <div className="citrus-ia-seccion__cabecera">
      {icono && (
        <span className="citrus-gpt-icon citrus-ia-seccion__icono">
          <SvgComponent iconName={icono} width="16px" height="16px" fill="currentColor" />
        </span>
      )}
      <h3>{titulo}</h3>
      {acciones && <div className="citrus-ia-seccion__acciones">{acciones}</div>}
    </div>
    <div className="citrus-ia-seccion__cuerpo">{children}</div>
  </div>
);

export const HtmlSaneado = ({ html, className }) => (
  <div
    className={`citrus-gpt-msg__burbuja citrus-ia-html${className ? ` ${className}` : ""}`}
    dangerouslySetInnerHTML={{ __html: html || "" }}
  />
);
